import { render, staticRenderFns } from "./RsaSchedaPazienteComponent.vue?vue&type=template&id=5c20d287&scoped=true"
import script from "./RsaSchedaPazienteComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaPazienteComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaSchedaPazienteComponent.vue?vue&type=style&index=0&id=5c20d287&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c20d287",
  null
  
)

export default component.exports